import React from 'react';
import { motion } from 'framer-motion';

export function Reveal({ children, delay = 0, className = '', y = 30 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-60px' }}
      transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLines({ lines, className = '', lineClassName = '', colors = [], as: Tag = 'h1' }) {
  const MotionTag = motion[Tag] || motion.h1;
  return (
    <MotionTag className={className}>
      {lines.map((line, i) => (
        <span key={i} className="mask-line">
          <motion.span
            className={`${lineClassName} ${colors[i] || ''}`}
            initial={{ y: '110%' }}
            animate={{ y: '0%' }}
            transition={{ duration: 0.9, delay: 0.15 + i * 0.13, ease: [0.16, 1, 0.3, 1] }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </MotionTag>
  );
}

export function SectionHead({ overline, title, className = '', align = 'left' }) {
  return (
    <Reveal className={`${align === 'center' ? 'text-center' : ''} ${className}`}>
      {overline && (
        <p className="text-sm font-semibold tracking-wide text-blue-400 mb-3" data-testid="section-overline">
          {overline}
        </p>
      )}
      <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-white leading-[1.1]">
        {title}
      </h2>
    </Reveal>
  );
}
